
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M17.1429 6.85693L6.85718 17.1426M6.85718 6.85693L17.1429 17.1426",
        "stroke": "#40454E",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    }
  ]
})
    }
  